import UserProfile from "../Boilerplate/UserProfile";
import {connect} from "react-redux";
import {registerAccount} from "../../actions/users";
import {setViewPath} from "../../actions/view";

const UserRegistration = connect(
  null,
  (dispatch, props) => ({
    onSubmit: (values) => {
      const { password: newPassword, ...user } = values;
      const { sid } = ((props||{}).match||{}).params||{};
      dispatch(setViewPath());
      dispatch(registerAccount(sid, user, newPassword, () => props.history.push('/')));
    }
  })
)(UserProfile);

UserRegistration.propTypes = {};

export default UserRegistration;



// WEBPACK FOOTER //
// ./src/components/Security/UserRegistration.js